import { Fetcher } from '@this/src/util';
/* eslint-disable max-lines */
import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import { styled } from '@this/constants/themes';
import ShareholderTicketList from '@this/domain/shareholder_ticket_list/index';
import type ShareholderTicket from '../../../domain/shareholder_ticket';
import DeliveryAndBookingCardList from './delivery_and_booking_card_list/delivery_and_booking_card_list';
import TripTodoList from './trip_todo_list';
import TicketingInstruction from './ticketing_instruction/ticketing_instruction';
import Ticketing from './ticketing/ticketing';
import SendList from './send_list/send_list';
import OrderItemTodoList from './order_item_todo_list/order_item_todo_list';
import OrderItemStepTodoList from './order_item_step_todo_list/order_item_step_todo_list';
import AutoReservationInventory from './auto_reservation_inventory/auto_reservation_inventory';
import MessageBulkSendList from './message_bulk_send_list/message_bulk_send_list';

const Tab = {
  STEP: 'STEP(OrderItemStep)ごと',
  ORDER_ITEM: '商品(OrderItem)ごと',
  TRIP: '旅程(Trip)ごと',
  DELIVERY_AND_BOOKING: 'ブッキング・デリバリーチェック',
  TICKETING_INSTRUCTION: '発券指示',
  TICKETING: '発券',
  CREATE_SEND_LIST: '送付状作成',
  AUTO_RESERVATION_INVENTORY: '自動予約棚卸',
  MESSAGE_BULK_SEND: 'メッセージ一括送信'
} as const;
export type TabType = keyof typeof Tab;
const AllTab: TabType[] = _.keys(Tab) as TabType[];

interface ShareholderTicketResponse {
  tickets: ShareholderTicket[];
}

interface Props {
  serviceId: number;
}

const getInitialTab = (): TabType => {
  const tabParam = utils.getParam('tab') as TabType;
  return AllTab.includes(tabParam) ? tabParam : 'ORDER_ITEM';
};

const TodoList = observer(({ serviceId }: Props) => {
  const [currentModel, setCurrentModel] = useState<TabType>(getInitialTab());
  const [ticketCount, setTicketCount] = useState<{ [carrier: string]: number }>({});

  const fetchShareholderTickets = useCallback(() => {
    Fetcher.get<ShareholderTicketResponse>('/arrangement/shareholder_tickets.json', {
      status: 0, // 未使用
      expire_at: 0, // 期限内
      is_deleted: 0 // 未削除
    }).then(response => {
      const tickets = new ShareholderTicketList(response.tickets);
      const result: { [carrier: string]: number } = {};
      result.ANA = 0;
      result.JAL = 0;
      result.SFJ = 0;

      tickets.list.forEach(t => {
        switch (t.companyStr()) {
          case 'ANA':
            result.ANA += 1;
            break;
          case 'JAL':
            result.JAL += 1;
            break;
          case 'SFJ':
            result.SFJ += 1;
            break;
          default:
            break;
        }
      });
      setTicketCount(result);
    });
  }, []);

  const handleChange = useCallback(
    tab => {
      setCurrentModel(tab);
    },
    [setCurrentModel]
  );

  useEffect(() => {
    fetchShareholderTickets();
  }, [fetchShareholderTickets]);

  useEffect(() => {
    document.title = `${Tab[currentModel]} - TODO`;
    return () => {
      document.title = '管理画面';
    };
  }, [currentModel]);

  return (
    <Wrapper>
      <div style={{ display: 'flex' }}>
        <div>
          <SelectModel>
            {AllTab.map(tab => (
              <Label key={tab}>
                <input type="radio" checked={currentModel === tab} onChange={() => handleChange(tab)} />
                {Tab[tab]}
              </Label>
            ))}
          </SelectModel>
        </div>
      </div>
      {currentModel === 'STEP' && <OrderItemStepTodoList serviceId={serviceId} />}
      {currentModel === 'ORDER_ITEM' && <OrderItemTodoList serviceId={serviceId} ticketCount={ticketCount} />}
      {currentModel === 'TRIP' && <TripTodoList />}
      {currentModel === 'DELIVERY_AND_BOOKING' && <DeliveryAndBookingCardList />}
      {currentModel === 'TICKETING_INSTRUCTION' && <TicketingInstruction />}
      {currentModel === 'TICKETING' && <Ticketing />}
      {currentModel === 'CREATE_SEND_LIST' && <SendList />}
      {currentModel === 'AUTO_RESERVATION_INVENTORY' && <AutoReservationInventory />}
      {currentModel === 'MESSAGE_BULK_SEND' && <MessageBulkSendList />}
    </Wrapper>
  );
});

const Wrapper = styled.div`
  padding: 20px;
  font-size: 12px;
`;

const SelectModel = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const Label = styled.label`
  margin-right: 20px;
`;

export default TodoList;
